import { SagaReduxAction } from './helper';

export const ItinerariesListener = new SagaReduxAction('ITINERARIES_LISTENER');
export const ItineraryAdded = new SagaReduxAction('ITINERARY_NEW', doc => doc);
export const ItineraryRemoved = new SagaReduxAction('ITINERARY_STALE', id => id); 